import { valueAsString } from "@tsmono/util";

import { ScoreValue } from "../../../@types/extraInspect";
import { kScoreTypeBoolean, kScoreTypePassFail } from "../../../constants";

export type Tone = "pass" | "fail" | "warn" | "neutral";

/**
 * Maps a score value to a visual tone for the V2 sample header.
 *
 * The classification is intentionally conservative for numeric scores —
 * inspect numbers can mean accuracy, latency, token counts, anything,
 * so we never auto-color them. Grades (passfail) and booleans have
 * unambiguous semantics; strings honor only an explicit pass/fail
 * vocabulary.
 */
export function scoreTone(
  value: ScoreValue | null | undefined,
  scoreType: string
): Tone {
  if (value === undefined || value === null) return "neutral";

  if (scoreType === kScoreTypePassFail) {
    const s = valueAsString(value).toUpperCase();
    if (s === "C" || s === "A" || s === "B") return "pass";
    if (s === "I" || s === "F" || s === "N") return "fail";
    if (s === "P") return "warn";
    return "neutral";
  }

  if (scoreType === kScoreTypeBoolean || typeof value === "boolean") {
    return value ? "pass" : "fail";
  }

  if (typeof value === "string") {
    const s = value.toLowerCase().trim();
    if (s === "pass" || s === "yes" || s === "ok" || s === "true") {
      return "pass";
    }
    if (s === "fail" || s === "no" || s === "false") return "fail";
    return "neutral";
  }

  return "neutral";
}
